import {$qs} from '../../../@shared/ts/dom';
import {type WCPHPData} from '../../../@type/woocommerce/php-data';
import {peachpay_initButton, shouldLoadButtonBasedOnAccountSettings} from '../button';
import {peachpay_isElementor} from '../product-page';

declare const peachpay_data: WCPHPData;

declare global {
	interface Window {
		elementorModules?: any;
		elementorFrontend?: any;
	}
}
if (window?.elementorModules && window?.elementorFrontend) {
	class PeachPayHandlerClass extends window.elementorModules.frontend.handlers.Base {
		getDefaultSettings() {
			$qs('#pp-button-text', $el => {
				peachpay_data.button_text = $el.innerText;
				peachpay_data.button_color = window.getComputedStyle($el).color;
			});
		}
	}

	jQuery(window).on('elementor/frontend/init', () => {
		const addHandler = ($element: HTMLElement) => {
			// eslint-disable-next-line @typescript-eslint/no-unsafe-call
			window.elementorFrontend.elementsHandler.addHandler(PeachPayHandlerClass, {
				$element,
			});
		};

		// eslint-disable-next-line @typescript-eslint/no-unsafe-call
		window.elementorFrontend.hooks.addAction('frontend/element_ready/peachpay.default', addHandler);
	});

	document.addEventListener('DOMContentLoaded', () => {
		if (!shouldLoadButtonBasedOnAccountSettings()) {
			return;
		}

		if (peachpay_isElementor()) {
			const button = $qs('#pp-button-shortcode') ?? $qs('#pp-button');
			const shortcodeProductId = button?.dataset?.['specificProductId'];
			const shortcodeProductQuantity = Number.parseInt(button?.dataset?.['specificProductQuantity'] ?? '1');
			peachpay_data.is_elementor_product_page = button?.dataset?.['isElementorProductPage'] === 'yes';

			if (shortcodeProductId) {
				peachpay_initButton({
					width: '350',
					isShortcode: true,
					isElementor: true,
					shortcodeInfo: {
						// TODO how should this be handled @sandeep? I am assuming right now negative numbers are not currently used
						shortcodeId: -1,
						productId: Number.parseInt(shortcodeProductId),
						quantity: shortcodeProductQuantity,
					},
				});
			} else {
				peachpay_initButton({width: '350', isElementor: true});
			}
		}
	});
}

